<template>
  <div class="public_head">
    <el-container>
      <!-- 头部导航栏 -->
      <el-header>
        <div class="demo-image">
          <!-- <img src="../assets/logo9.png" alt /> -->
          <img :src="idLogo" alt/>
        </div>
        <div class="demo-wenzi">
          <img src="../assets/fnjkj11.png" alt/>
        </div>
        <div class="right" @click="toggle">
          <div class="item hover-effect" v-if="hasPermission(68)">
            <el-dropdown trigger="click">
              <div class="dp el-dropdown-link" @click="handleDP">
                <div class="iconfont">
                  <svg-icon icon-class="changeDP" style="font-size: 30px"></svg-icon>
                </div>
                <div class>换电大屏</div>
              </div>
              <el-dropdown-menu slot="dropdown" :visible-arrow="false"></el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="item hover-effect" v-if="hasPermission(401)">
            <el-dropdown trigger="click">
              <div class="dp el-dropdown-link" @click="handleLeaseDP">
                <div class="iconfont">
                  <svg-icon icon-class="zulindp" style="font-size: 40px"></svg-icon>
                </div>
                <div class>租赁大屏</div>
              </div>
              <el-dropdown-menu slot="dropdown" :visible-arrow="false"></el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="item hover-effect" v-if="hasPermission(100)">
            <el-dropdown trigger="click">
              <div class="dp el-dropdown-link" @click="hadnlePay">
                <div class="iconfont">
                  <svg-icon icon-class="zhifu" style="font-size: 33px"></svg-icon>
                </div>
                <div class>支付大屏</div>
              </div>
              <el-dropdown-menu slot="dropdown"></el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="item hover-effect" v-if="hasPermission(290)">
            <el-dropdown trigger="click">
              <div class="dp el-dropdown-link" @click="handleLVWODP">
                <div class="iconfont">
                  <svg-icon icon-class="yunyingguanli" style="font-size: 33px"></svg-icon>
                </div>
                <div class>绿沃大屏</div>
              </div>
              <el-dropdown-menu slot="dropdown" :visible-arrow="false"></el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="item hover-effect" v-if="hasPermission(228)">
            <el-dropdown trigger="click">
              <div class="dp el-dropdown-link" @click="hadnleGLMDP">
                <div class="iconfont">
                  <svg-icon icon-class="yunyingguanli" style="font-size: 33px"></svg-icon>
                </div>
                <div class>格林美大屏</div>
              </div>
              <el-dropdown-menu slot="dropdown"></el-dropdown-menu>
            </el-dropdown>
          </div>
          <!-- <div class="item hover-effect" v-if="hasPermission(401)">
            <el-dropdown trigger="click">
              <div class="dp el-dropdown-link" @click="handleFTDP">
                <div class="iconfont">
                  <svg-icon icon-class="zulindp" style="font-size: 40px"></svg-icon>
                </div>
                <div class>丰田大屏</div>
              </div>
              <el-dropdown-menu slot="dropdown" :visible-arrow="false"></el-dropdown-menu>
            </el-dropdown>
          </div> -->
          <div class="item hover-effect"   v-if="hasPermission(317)">
            <el-dropdown trigger="click" @command="handleBigScreenClick">
              <div class="dp el-dropdown-link">
                <div class="iconfont">
                  <svg-icon icon-class="daping" style="font-size: 33px"></svg-icon>
                </div>
                <div class>大屏</div>
              </div>
              <el-dropdown-menu slot="dropdown" class="dropdown-user">
                <el-dropdown-item command="1">
                  <svg-icon icon-class="yunyingFnj" style="font-size: 18px;margin-right: 5px;"></svg-icon>
                  菲尼基大屏</el-dropdown-item>
                <el-dropdown-item command="2" divided>
                  <svg-icon icon-class="changeDP" style="font-size: 18px;margin-right: 5px;"></svg-icon>
                  换电大屏</el-dropdown-item>
                  <el-dropdown-item command="6" divided>
                  <svg-icon icon-class="zulindp" style="font-size: 22px;margin-right: 5px;"></svg-icon>
                  租赁大屏</el-dropdown-item>
                <el-dropdown-item command="3" divided>
                  <svg-icon icon-class="zhifu" style="font-size: 18px;margin-right: 5px;"></svg-icon>
                  支付大屏</el-dropdown-item>
                <!-- <el-dropdown-item command="4" divided >
                  <svg-icon icon-class="yunyingguanli" style="font-size: 18px;margin-right: 5px;"></svg-icon>
                  绿沃大屏</el-dropdown-item>
                <el-dropdown-item command="5" divided>
                  <svg-icon icon-class="yunyingguanli" style="font-size: 18px;margin-right: 5px;"></svg-icon>
                  格林美大屏</el-dropdown-item> -->
              </el-dropdown-menu>
            </el-dropdown>
          </div>

          <div class="item hover-effect">
            <el-dropdown trigger="click">
              <div class="dp el-dropdown-link" @click="handleToNew">
                <div class="iconfont">
                 <img src="../assets/newIcon.png" alt style="width:48px;height:52px;marginTop:-3px;" />
                </div>
                <div >新版</div>
              </div>
              <el-dropdown-menu slot="dropdown"></el-dropdown-menu>
            </el-dropdown>
          </div>

          <div class="item hover-effect">
            <el-dropdown trigger="click" @command="handleCommand">
              <div class="dp el-dropdown-link">
                <div class="iconfont">
                  <svg-icon icon-class="guanliyuan" style="font-size: 35px"></svg-icon>
                </div>
                <div class>{{username}}</div>
              </div>
              <el-dropdown-menu slot="dropdown" class="dropdown-user">
                <el-dropdown-item command="1">修 改 密 码</el-dropdown-item>
                <el-dropdown-item command="2" divided>退 出 登 录</el-dropdown-item>
                <el-dropdown-item command="3" divided class="alarmTip" >
                  <div class="control-btn" @click="handleAlarm()">
                    <img :src="require('@/assets/openBtn.png')" alt="" v-if="alarmBtn">
                    <img :src="require('@/assets/offBtn.png')" alt="" v-else>
                  </div>
                   <div class="btn-text" style="margin-left:7px;float:left">告警提示</div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>


          <div class="item hover-effect" style="margin-right: 0px">
            <el-dropdown trigger="click" @command="handleChangeTheme">
              <div class="dp el-dropdown-link" style="margin-right: 0px">
                <div class="iconfont" style="">
                  <svg-icon icon-class="gengduo" style="font-size: 20px"></svg-icon>
                </div>

              </div>
              <el-dropdown-menu slot="dropdown">

                <el-dropdown-item command="theme2">
                  <div style="display: flex;align-items: center">
                    <svg-icon icon-class="chuantonghei" style="font-size: 18px;margin-right: 5px;"></svg-icon>
                    传统黑
                  </div>

                </el-dropdown-item>

                <el-dropdown-item command="theme1">
                  <div style="display: flex;align-items: center">
                    <svg-icon icon-class="keji" style="font-size: 22px;margin-left: -3px;margin-right: 5px"></svg-icon>
                    科技蓝
                  </div>
                </el-dropdown-item>

                <el-dropdown-item command="theme2_skyblue">
                  <div style="display: flex;align-items: center">
                    <svg-icon icon-class="baicai" style="font-size: 14px;margin-left: 0px;margin-right: 10px"></svg-icon>
                    极光白
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>

        </div>
        <div class="tanchuang">
          <el-dialog v-dialogDrag  title="修改密码" :visible.sync="dialogVisible" width="35%" :modal-append-to-body="false">
            <el-form
              :model="ruleForm"
              status-icon
              :rules="rules"
              ref="ruleForm"
              label-width="150px"
              class="demo-ruleForm"
            >
              <el-form-item label="请输入原密码" prop="pass">
                <el-input v-model="ruleForm.pass" placeholder="请输入原密码"></el-input>
              </el-form-item>
              <el-form-item label="请输入新密码" prop="newPass">
                <el-input v-model="ruleForm.newPass" placeholder="请输入新密码"></el-input>
              </el-form-item>
              <el-form-item label="请确认新密码" prop="checkPass">
                <el-input v-model="ruleForm.checkPass" placeholder="请再次输入新密码"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button
                  class="end"
                  type="primary"
                  @click="submitForm('ruleForm'),dialogVisible == false"
                >提交
                </el-button>
              </el-form-item>
            </el-form>
          </el-dialog>
        </div>
      </el-header>
    </el-container>
    <div class="headColor"></div>
    <Alarmtips ref='alarmtips'></Alarmtips>
  </div>
</template>
<style lang="scss" scoped>

  .headColor {

    [data-theme="theme1"] & {
      width: 100%;
      height: 3px;
      background: linear-gradient(270deg, rgba(0, 255, 245, 0) 0%, rgba(0, 255, 246, 1) 50%, rgba(0, 128, 123, 0) 100%);
    }


  }

  .el-header {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    height: 57px !important;
    line-height: 57px;
    color: #ffffff;
    background: #001F38;
    // background: linear-gradient(to right, #48D0FF, #1167E9);/*标准语法*/
    // box-shadow:0px 7px 10px rgba(47, 106, 196 ,0.8) ;
    z-index: 2003;
    // background: -webkit-linear-gradient(left, #48D0FF, #1167E9); /* Safari 5.1 - 6.0 */
    // background: -o-linear-gradient(right,#48D0FF, #1167E9); /* Opera 11.1 - 12.0 */
    // background: -moz-linear-gradient(right, #48D0FF, #1167E9); /* Firefox 3.6 - 15 */
  }

  [data-theme="theme2_skyblue"]
  .el-header{
    background: linear-gradient(to left,rgb(72, 173, 255), #1167E9);
    box-shadow:0px 6px 20px rgba(19,107,234 ,0.5) ;
  }

  .demo-image {
    width: 193px;
    height: 45px;
    margin-top: 4px;
    // [data-theme="theme2"] & {
    //   padding-top:10px;
    // }
  }

  .demo-wenzi {
    width: 305px;
    height: 37px;
    margin-top: 5px;
    margin-left: 28px;
  }

  .demo-image img {
    width: 100%;
    height: 100%;
  }

  .demo-wenzi img {
    width: 100%;
    height: 100%;
  }

  .el-dropdown-link {
    cursor: pointer;
  }

  .el-dropdown-link:focus {
    outline: none;
  }

  .right {
    display: flex;
    position: absolute;
    right: 0;
    top: 0;
    cursor: pointer;
    text-align: right;

    .item {


      margin-right: 20px;
      /*line-height: 60px;*/
      .iconfont {
        height: 57px;
        width: 36px;
        padding-right: 10px;
        display: flex;
        align-items: center;
      }

      .dp {
        line-height: 50px;
        margin-right: 15px;

        [data-theme="theme1"] & {
          color: #00ECE5;
        }

        [data-theme*="theme2"] & {
          color: #fff;
        }


        div {
          float: left;
          line-height: 57px;
          font-size: 16px;
        }
      }
    }

    .hover-effect {
      cursor: pointer;
      transition: background 0.3s;

      &:hover {
        background: rgba(0, 0, 0, 0.025);
      }
    }
  }

  .twochange {
    width: 150px;
    height: 100px;
    z-index: 1000;
    position: absolute;
    left: 0;
  }

  .change {
    border: 1px solid #cccccc;
    width: 150px;
    height: 25px;
    line-height: 25px;
    background: inherit;
    background-color: rgb(25, 34, 48);

    border-radius: 0px;
    display: block;
    padding: 0;
    color: #ffffff;
    text-align: center;
  }

  .end {
    border-radius: 24px;
    width: 88px;
    height: 32px;
    font-size: 14px;
    line-height: 7px;
    background: rgba(8, 107, 175, 0.99);
    color: rgb(255, 255, 255);
    position: absolute;
    right: -25%;
    border: none;
  }
  // 提醒控制
  .dropdown-user{
    .el-dropdown-menu__item{
      padding: 0 25px!important;
    }
    .alarmTip{
    padding: 0px 10px!important;
   &:before {
      margin: 0 -10px!important;
    }
    .control-btn{
    width: 40px;
    height: 21px;
    float: left;
    line-height: 45px;
    img{
      width: 100%;
      height: 100%;padding-right: 10px;
    }
  }
  }
  }

</style>
<script>
    import router from "../router";
    import {findSIM, importXlxSIM} from "@/services/inventory";
    import Alarmtips from "./Alarmtips/index";
    import {EventBus} from '@/utils/event-bus';
    import {getUserId} from "@/utils/auth";
    import {loadLogo,editVersionSum} from "@/services/role";
    import {isPasswordValid} from '@/utils/validate.js'
    export default {
      components:{Alarmtips},
        data() {
            let regPass = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/;
            var validatePass = (rule, value, callback) => {
                if (value === "" || !isPasswordValid(value)) {
                     callback(new Error("请输入8位以上的数字、字母、特殊字符中任意两类的组合"));
                } else {
                    if (this.ruleForm.checkPass !== "") {
                        this.$refs.ruleForm.validateField("checkPass");
                    }
                    callback();
                }
            };
            var validatePass2 = (rule, value, callback) => {
                if (value === "") {
                    callback(new Error("请再次输入密码"));
                } else if (value !== this.ruleForm.newPass) {
                    callback(new Error("两次输入密码不一致!"));
                } else {
                    callback();
                }
            };
            return {
                head1: require("../assets/head1.png"),
                head2: require("../assets/head2.png"),
                head3: require("../assets/head3.png"),
                url: require("../assets/header.png"),
                idLogo: null,
                isshow1: false,
                isshow: false,
                username: "",
                dialogVisible: false,
                ruleForm: {
                    pass: "",
                    newPass: "",
                    checkPass: ""
                },
                rules: {
                    pass: [{required: true, message: "请输入密码", trigger: "blur"}],
                    newPass: [{required: true, validator: validatePass, trigger: "blur"}],
                    checkPass: [
                        {required: true, validator: validatePass2, trigger: "blur"}
                    ]
                },
                roleData: "",
                arr1: [],
                alarmBtn:true
            };
        },
        methods: {
            //权限控制
            hasPermission(id) {
                return this.$store.getters.hasPermission(id);
            },
               // 大屏（下拉展示）
          hadnleMixBigData(){
             let routeUrl = this.$router.resolve({
                    path: "/dashboard/hadnleMixData"
                });
                window.open(routeUrl.href, "_blank");
          },
            hadnlePay() {
                let routeUrl = this.$router.resolve({
                    path: "/dashboard/pay"
                });
                window.open(routeUrl.href, "_blank");
            },
            handleDP() {
                let routeUrl = this.$router.resolve({
                    path: "/dashboard/analysis"
                });
                window.open(routeUrl.href, "_blank");
            },
            handleLeaseDP() {
                let routeUrl = this.$router.resolve({
                    path: "/dashboard/analysis2"
                });
                window.open(routeUrl.href, "_blank");
            },
            handleFTDP(){
              let routeUrl = this.$router.resolve({
                    path: "/ft/ftLargeDigitalScreen"
                });
                window.open(routeUrl.href, "_blank");
            },
            handleLVWODP() {
                let routeUrl = this.$router.resolve({
                    path: "/dashboard/lvwoAnalysis"
                });
                window.open(routeUrl.href, "_blank");
            },
             //格林美运营大屏
             hadnleGLMDP() {
                let routeUrl = this.$router.resolve({
                    path: "/dashboard/greenBeauty"
                });
                window.open(routeUrl.href, "_blank");
            },
            async handleToNew(){
              const res =await editVersionSum({type:2})

             let role= sessionStorage.getItem("IDS",);
             role=JSON.parse(role)

                  if (role.find(item=>{return item==708})) {
                    window.location="https://service.fnjkj.cn/new/#/dataStatisticsHomePage";
                    //  window.location="http://admin.lvwo.info/new/#/dataStatisticsHomePage"

                  }else if(role.find(item=>{return item==2})){
                    window.location="https://service.fnjkj.cn/new/#/battery/index";
                    //  window.location="http://admin.lvwo.info/new/#/battery/index"

                  } else {
                    window.location="https://service.fnjkj.cn/new/#/spacepage";
                    //  window.location="http://admin.lvwo.info/new/#/spacepage"
                  }
            },

            handleBigScreenClick(type) {
                type=Number.parseInt(type);
                switch (type) {
                    case 1:
                        this.hadnleMixBigData();
                        break;
                    case 2:
                        this.handleDP();
                        break;
                    case 3:
                        this.hadnlePay();
                        break;
                    case 4:
                        this.handleLVWODP();
                        break;
                    case 5:
                        this.hadnleGLMDP();
                        break;
                    case 6:
                        this.handleLeaseDP();
                        break;
                }




            },

            handleCommand(type) {
                if (type == 1) {
                    this.dialogVisible = true;
                } else if (type == 2) {
                    this.logOut();
                }
            }, handleChangeTheme(theme) {
                window.document.documentElement.setAttribute('data-theme', theme)
                localStorage.setItem("theme", theme);
                this.$store.dispatch('settings/changeSetting', {
                    key: 'theme',
                    value: theme
                })
            },

            toggle() {
                this.isshow = !this.isshow; //取反
            },

            // handleClose(done) {
            //   this.dialogVisible = false;
            // },
            // 退出登录
            logOut() {
                // console.log("退出登录");
                this.$axios.post("/user/logout").then(result => {
                    // console.log(result.data);
                    sessionStorage.removeItem("token");
                    if (result.data.code == 0) {
                        // this.$store.getters.permission = []
                        this.$store.dispatch('permission/setPermission', [])
                        // console.log(this.$store,22)
                        EventBus.$emit("closeConnect"); //断开连接
                        this.$router.push({path: "/"});
                        window.location.reload(); //清空上一个登录账号的路由信息

                        this.$message({
                            message: "退出登录",
                            type: "success",
                            showClose: true,
                            duration: 2000
                        });

                    }
                });
            },
            // 修改密码
            submitForm(formName) {
                let regPass = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/;
                // console.log(this.ruleForm.pass);
                // console.log(this.ruleForm.newPass);
                // console.log(this.ruleForm.checkPass);
                if (
                    this.ruleForm.newPass != this.ruleForm.checkPass ||
                    !isPasswordValid(this.ruleForm.newPass)  ||
                    this.ruleForm.pass == "" ||
                    this.ruleForm.pass == " "
                ) {
                    this.$refs[formName].validate(valid => {
                    });
                    this.dialogVisible = true;
                    this.$message({
                        message: "密码修改不成功！！！",
                        type: "error",
                        showClose: true,
                        duration: 2000
                    });
                } else {
                    let upData = {
                        oldPassword: this.ruleForm.pass, //唯一标识符，让其知道是在修改这条数据
                        newPassword: this.ruleForm.newPass
                    };
                    // console.log(upData);
                    this.$axios
                        .post(
                            "/user/updatePassword?oldPassword=" +
                            this.ruleForm.pass +
                            "&newPassword=" +
                            this.ruleForm.newPass
                        )
                        .then(result => {
                            // console.log(result.data);
                            if (result.data.code == 0) {
                                this.$message({
                                    message: "恭喜你，密码修改成功",
                                    type: "success",
                                    showClose: true,
                                    duration: 2000
                                });

                                this.dialogVisible = false;
                                this.logOut();
                                $(".twochange").hide();
                            } else  {
                                this.$message({
                                    message:result.data.data,
                                    type: "error",
                                    showClose: true,
                                    duration: 5000
                                });
                            }
                        });
                }
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            },
            idlogo() {
                if(sessionStorage.getItem("loginName")=="DLXNY001"){
                    this.idLogo ="http://fnjkj.oss-cn-beijing.aliyuncs.com/images1/1618366065981.png";
                    return;
                }

                let logo= localStorage.getItem("logo");
                if(logo){
                    this.idLogo =logo;
                }else{
                    this.idLogo = require("../assets/fnj002.png");
                }
                loadLogo().then(res=>{
                     if(res){
                         localStorage.setItem("logo",res.data)
                     }else{
                         localStorage.setItem("logo","")
                     }
                    let logo= localStorage.getItem("logo");
                    if(logo){
                        this.idLogo =logo;
                    }else{
                        this.idLogo = require("../assets/fnj002.png");
                    }
                });



               /* let than = this;
                than.$axios
                    .post("/operatorController/selectByOperatorPic")
                    .then(res => {
                        // console.log(res.data.data)
                        than.idLogo = res.data.data;
                        let smg = "该用户运营商未添加logo";
                        if (this.idLogo == smg) {
                            this.idLogo = require("../assets/fnj002.png");
                        }
                    })
                    .catch(err => {
                        console.log(err);
                    });*/
            },
        // 提醒设置
        handleAlarm(){
          this.alarmBtn=!this.alarmBtn;
          // console.log(this.alarmBtn)
          if(this.alarmBtn==true){
            // 开启告警推送，调用推送的函数
            // 弹窗出现
            localStorage.setItem("is_receive",true)  //接收消息
            EventBus.$emit("connect",getUserId())  // 开始连接,传useid过去
          }else {
             localStorage.setItem("is_receive",false)  //不接消息
             EventBus.$emit("closeConnect")  //断开连接
            // 弹窗关闭
          }
        }
        },
        created() {
            var than = this;
            this.username = sessionStorage.getItem("username");
            let isReceive= localStorage.getItem("is_receive");

            if(!(isReceive=='false')){
              this.alarmBtn=true
            }else{
              this.alarmBtn=false;
            }
            // this.dpshow()
        },
        mounted() {
            this.idlogo();
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/Head.vue